import React, { createContext, FC, useState } from 'react';
import {
  ExternalAutoFormContextI,
  ExternalAutoFormProviderProps,
} from './mfExternalAutoForm.types';
import { ExternalAutoInfoResponse } from '../components/Card/Card.types';
import { LocalStorageKeys } from '../constants';

const emptyAutoInfo = {
  brandName: '',
  modelName: '',
  year: '',
  price: '',
  mainPictureUrl: '',
  kmTraveled: '',
};

const leadId = localStorage.getItem(LocalStorageKeys.LEAD_ID) || '';

export const ExternalAutoFormContext = createContext<ExternalAutoFormContextI>({
  leadIdState: [leadId, (value: string): string => value],
  goTo: {
    toPersonalInfo: '',
    toHasAnApplication: '',
  },
  autoInfoState: [
    emptyAutoInfo,
    (autoInfo): ExternalAutoInfoResponse => autoInfo,
  ],
});

export const ExternalAutoFormProvider: FC<ExternalAutoFormProviderProps> = ({
  children,
  goTo,
}) => (
  <ExternalAutoFormContext.Provider
    value={{
      leadIdState: useState(leadId),
      goTo,
      autoInfoState: useState(emptyAutoInfo),
    }}
  >
    {children}
  </ExternalAutoFormContext.Provider>
);
